import { ComponentProps, FC, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import SearchInput from '../SearchInput';

type TableSearchInputProps = {
  onSearchChange?: (value: string) => void;
  paramKeys?: string[];
} & ComponentProps<typeof SearchInput>;

const TableSearchInput: FC<TableSearchInputProps> = ({
  value: controlledValue,
  onSearchChange,
  paramKeys = ['searchingQuery'],
  ...rest
}) => {
  const [searchParams] = useSearchParams();

  const getInitialValue = () => {
    for (const key of paramKeys) {
      const value = searchParams.get(key);
      if (value) return JSON.parse(value);
    }
    return '';
  };

  const initialValue = getInitialValue();
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (initialValue) {
      onSearchChange?.(initialValue);
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onSearchChange?.(newValue);
  };

  return <SearchInput value={value} onChange={handleChange} {...rest} />;
};

export default TableSearchInput;
